import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { fallIn, moveIn, moveInLeft } from './router.animations';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [moveIn(), fallIn(), moveInLeft()],
  host: { '[@moveIn]': ''}
})

export class AppComponent implements OnInit {
  title = 'user-app';

  constructor(
    private _authService: AuthService,
    private _router: Router) {

  }

  ngOnInit(): void {
    //this.getBanners();
  }
  public getBanners() {
    // this._BannerService.getBanners().subscribe((res) => {
    //     console.log(res);
    // })
  }
}
